(function () {
  if (window.__townwineFollowAssetLoaded) {
    if (typeof window.TownWineFollow.init === 'function') {
      window.TownWineFollow.init(document);
    }
    return;
  }

  window.__townwineFollowAssetLoaded = true;

  var DEFAULT_PROXY_BASE = '/apps/townwine-follow';
  var FOLLOW_LABEL = '팔로우';
  var FOLLOWING_LABEL = '팔로잉';
  var FOLLOW_NOTICE_STORAGE_KEY = 'townwine-follow-notice';
  var FOLLOW_NOTICE_UNFOLLOWED = 'unfollowed';
  var initialized = false;
  var loginStateByProxy = Object.create(null);
  var FOLLOW_BIND_VERSION = '20260523a';

  function getCustomerContext() {
    var customer = window.TownWineCustomer || {};

    return {
      id: String(customer.id || '').trim(),
      email: String(customer.email || '').trim(),
      firstName: String(customer.firstName || '').trim(),
      shopDomain: String(customer.shopDomain || '').trim(),
    };
  }

  function appendCustomerParams(searchParams) {
    var customer = getCustomerContext();

    if (customer.email) {
      searchParams.set('customerEmail', customer.email);
    }

    if (customer.firstName) {
      searchParams.set('customerFirstName', customer.firstName);
    }

    return searchParams;
  }

  function normalizeHandle(value) {
    var handle = String(value || '').trim();

    if (!handle) return '';

    if (/^https?:\/\//i.test(handle)) {
      try {
        var url = new URL(handle);
        var segments = url.pathname.split('/').filter(Boolean);
        if (segments.length) {
          handle = segments[segments.length - 1];
        }
      } catch (error) {
        console.warn('[follow] failed to parse handle URL', error);
      }
    }

    handle = handle
      .split(/[?#]/, 1)[0]
      .replace(/^@+/, '')
      .replace(/\/+$/, '')
      .trim()
      .toLowerCase();

    try {
      handle = decodeURIComponent(handle);
    } catch (error) {
      console.warn('[follow] failed to decode handle', error);
    }

    return handle;
  }

  function getFollowButtons(root) {
    return Array.prototype.slice.call((root || document).querySelectorAll('.js-follow-btn'));
  }

  function getProxyBase(button) {
    return button.dataset.proxyBase || DEFAULT_PROXY_BASE;
  }

  function getFollowLabel(button) {
    return button.dataset.followLabel || FOLLOW_LABEL;
  }

  function getFollowingLabel(button) {
    return button.dataset.followingLabel || FOLLOWING_LABEL;
  }

  function getButtonDefaultHandle(button) {
    return normalizeHandle(button.dataset.followDefaultHandle || button.dataset.influencerHandle || '');
  }

  function getButtonHandle(button) {
    return normalizeHandle(button.dataset.influencerHandle || '');
  }

  function getButtonMatchHandles(button) {
    var aliases = [];
    var extraHandles = String(button.dataset.followMatchHandles || '')
      .split(',')
      .map(normalizeHandle)
      .filter(Boolean);
    var influencerName = normalizeHandle(button.dataset.influencerName || '');

    [getButtonHandle(button), getButtonDefaultHandle(button)]
      .concat(extraHandles)
      .concat(influencerName ? [influencerName] : [])
      .forEach(function (value) {
        if (value && aliases.indexOf(value) === -1) {
          aliases.push(value);
        }
      });

    return aliases;
  }

  function getReturnTo(button) {
    var fallback = window.location.pathname + window.location.search + window.location.hash;
    return String(button.dataset.returnTo || fallback || '/');
  }

  function getButtonRequestContext(button) {
    var customer = getCustomerContext();
    var shopDomain = String(
      (button && button.dataset && button.dataset.shopDomain) ||
        customer.shopDomain ||
        (window.Shopify && window.Shopify.shop) ||
        '',
    ).trim();
    var customerId = String(
      (button && button.dataset && button.dataset.customerId) ||
        customer.id ||
        '',
    ).trim();

    return {
      shopDomain: shopDomain,
      customerId: customerId,
    };
  }

  function appendRequestContext(searchParams, context) {
    if (context && context.shopDomain) {
      searchParams.set('shop', context.shopDomain);
    }

    if (context && context.customerId) {
      searchParams.set('logged_in_customer_id', context.customerId);
    }

    return searchParams;
  }

  function isSameFollowTarget(button, proxyBase, handle) {
    var normalizedHandle = normalizeHandle(handle);

    return (
      getProxyBase(button) === proxyBase &&
      Boolean(normalizedHandle) &&
      getButtonMatchHandles(button).indexOf(normalizedHandle) !== -1
    );
  }

  function syncButtonTarget(button, matchedHandle, isFollowing) {
    var nextHandle = normalizeHandle(matchedHandle || '') || getButtonDefaultHandle(button);

    button.dataset.influencerHandle = nextHandle;
    button.disabled = !nextHandle;
    setButtonState(button, isFollowing);
  }

  function setButtonState(button, isFollowing) {
    button.setAttribute('aria-pressed', isFollowing ? 'true' : 'false');
    button.textContent = isFollowing ? getFollowingLabel(button) : getFollowLabel(button);
  }

  function setButtonsState(proxyBase, handle, isFollowing) {
    getFollowButtons(document).forEach(function (button) {
      if (isSameFollowTarget(button, proxyBase, handle)) {
        syncButtonTarget(button, isFollowing ? handle : '', isFollowing);
      }
    });
  }

  function setButtonsDisabled(proxyBase, handle, disabled) {
    getFollowButtons(document).forEach(function (button) {
      if (isSameFollowTarget(button, proxyBase, handle)) {
        button.disabled = disabled;
      }
    });
  }

  function parseJsonSafely(rawText) {
    if (!rawText) return null;

    try {
      return JSON.parse(rawText);
    } catch (error) {
      console.warn('[follow] non-JSON response payload', rawText);
      return null;
    }
  }

  function getFriendlyErrorMessage(message, status) {
    if (
      typeof message === 'string' &&
      /load failed|failed to fetch|network request failed|networkerror/i.test(message)
    ) {
      return '네트워크 문제로 팔로우 요청을 완료하지 못했습니다. 잠시 후 다시 시도해 주세요.';
    }

    if (status === 404) {
      return '팔로우 앱이 아직 이 스토어에 연결되지 않았습니다. 앱 배포와 설치를 먼저 완료해 주세요. (HTTP 404)';
    }

    if (
      !message ||
      message === 'FOLLOW_REQUEST_FAILED' ||
      message === 'UNFOLLOW_REQUEST_FAILED' ||
      message === 'STATUS_REQUEST_FAILED'
    ) {
      if (status) {
        return '팔로우 처리 중 오류가 발생했습니다. (HTTP ' + status + ')';
      }

      return '팔로우 처리 중 오류가 발생했습니다.';
    }

    if (message === 'INFLUENCER_HANDLE_REQUIRED') {
      return '컬렉터 handle 값이 필요합니다.';
    }

    return message;
  }

  function isLoginRedirect(response) {
    return Boolean(
      response &&
        response.redirected &&
        (response.url.indexOf('/account/login') !== -1 || response.url.indexOf('/password') !== -1),
    );
  }

  function isHtmlResponse(response, rawText) {
    var contentType = (response && response.headers.get('content-type')) || '';

    if (contentType.indexOf('text/html') !== -1) {
      return true;
    }

    return /^\s*</.test(String(rawText || ''));
  }

  function fetchStatusSnapshot(proxyBase, handles, requestContext) {
    var handleList = (handles || []).filter(Boolean);

    if (!handleList.length) {
      return Promise.resolve({ following: [], loggedIn: loginStateByProxy[proxyBase] !== false });
    }

    var searchParams = appendRequestContext(
      appendCustomerParams(new URLSearchParams()),
      requestContext,
    );
    searchParams.set('handles', handleList.join(','));

    return fetch(proxyBase + '/status?' + searchParams.toString(), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    }).then(function (response) {
      if (!response.ok || isLoginRedirect(response)) {
        throw new Error('STATUS_REQUEST_FAILED');
      }

      return response.json();
    });
  }

  function sendMutationRequest(endpoint, payload) {
    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    }).then(function (response) {
      return response.text().then(function (rawText) {
        return {
          response: response,
          payload: parseJsonSafely(rawText),
          rawText: rawText,
        };
      });
    });
  }

  function syncStatuses(root) {
    var buttons = getFollowButtons(root || document);
    var groups = new Map();

    buttons.forEach(function (button) {
      var proxyBase = getProxyBase(button);
      var handle = getButtonHandle(button);
      var requestContext = getButtonRequestContext(button);

      if (!handle) {
        button.disabled = true;
        return;
      }

      if (!groups.has(proxyBase)) {
        groups.set(proxyBase, {
          handles: new Set(),
          requestContext: requestContext,
        });
      }

      getButtonMatchHandles(button).forEach(function (alias) {
        groups.get(proxyBase).handles.add(alias);
      });

      if (
        requestContext &&
        (requestContext.shopDomain || requestContext.customerId)
      ) {
        groups.get(proxyBase).requestContext = requestContext;
      }
    });

    groups.forEach(function (group, proxyBase) {
      var handleList = Array.from(group.handles);
      if (!handleList.length) return;

      fetchStatusSnapshot(proxyBase, handleList, group.requestContext)
        .then(function (payload) {
          if (!payload || !Array.isArray(payload.following)) return;

          loginStateByProxy[proxyBase] = payload.loggedIn !== false;

          var followingSet = new Set(
            payload.following.map(function (value) {
              return normalizeHandle(value);
            }),
          );

          getFollowButtons(document).forEach(function (button) {
            var matchedHandle = getButtonMatchHandles(button).find(function (value) {
              return followingSet.has(value);
            });
            var isFollowing = Boolean(matchedHandle);

            if (!getButtonDefaultHandle(button) || getProxyBase(button) !== proxyBase) return;

            syncButtonTarget(button, matchedHandle, isFollowing);
          });
        })
        .catch(function (error) {
          console.warn('[follow] failed to sync statuses', error);
        });
    });
  }

  function handleUnauthorized() {
    if (window.self !== window.top) {
      window.alert('테마 미리보기에서는 고객 로그인 세션이 전달되지 않아 팔로우 테스트가 제한될 수 있습니다. 실제 스토어프론트 프리뷰 URL에서 고객 로그인 후 다시 확인해 주세요.');
      return;
    }

    var returnTo = window.location.pathname + window.location.search + window.location.hash;
    window.location.href = '/account/login?return_url=' + encodeURIComponent(returnTo);
  }

  function storeFollowNotice(notice) {
    if (!notice) return;

    try {
      window.sessionStorage.setItem(FOLLOW_NOTICE_STORAGE_KEY, notice);
    } catch (error) {
      console.warn('[follow] failed to persist notice', error);
    }
  }

  function consumeFollowNotice() {
    try {
      var notice = window.sessionStorage.getItem(FOLLOW_NOTICE_STORAGE_KEY) || '';
      if (notice) {
        window.sessionStorage.removeItem(FOLLOW_NOTICE_STORAGE_KEY);
      }

      return notice;
    } catch (error) {
      console.warn('[follow] failed to read notice', error);
      return '';
    }
  }

  function showFollowNotice(notice) {
    if (notice === FOLLOW_NOTICE_UNFOLLOWED) {
      window.alert('팔로우가 취소됐습니다.');
    }
  }

  function showPendingFollowNotice() {
    showFollowNotice(consumeFollowNotice());
  }

  function isRecoverableNetworkError(error) {
    var name = String((error && error.name) || '').toLowerCase();
    var message = String((error && error.message) || '').toLowerCase();

    if (!message && name !== 'typeerror') {
      return false;
    }

    return /load failed|failed to fetch|network request failed|networkerror/i.test(message);
  }

  function submitMutationRequestFallback(endpoint, payload, options) {
    if (!endpoint || !payload || !document.body) {
      return false;
    }

    if (options && options.notice) {
      storeFollowNotice(options.notice);
    }

    var form = document.createElement('form');
    form.method = 'post';
    form.action = endpoint;
    form.hidden = true;

    Object.keys(payload).forEach(function (key) {
      var value = payload[key];
      if (value == null || value === '') return;

      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = String(value);
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();

    return true;
  }

  function scheduleStatusSync() {
    var runSync = function () {
      syncStatuses(document);
    };

    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(runSync, { timeout: 1500 });
      return;
    }

    window.setTimeout(runSync, 0);
  }

  function resolveLoggedInState(proxyBase, handles, requestContext) {
    var handleList = Array.isArray(handles) ? handles.filter(Boolean) : [normalizeHandle(handles)];

    if (loginStateByProxy[proxyBase] != null) {
      return Promise.resolve(loginStateByProxy[proxyBase] !== false);
    }

    return fetchStatusSnapshot(proxyBase, handleList, requestContext)
      .then(function (payload) {
        loginStateByProxy[proxyBase] = payload && payload.loggedIn !== false;

        if (payload && Array.isArray(payload.following)) {
          var followingSet = new Set(
            payload.following.map(function (value) {
              return normalizeHandle(value);
            }),
          );

          handleList.forEach(function (handle) {
            if (followingSet.has(handle)) {
              setButtonsState(proxyBase, handle, true);
            }
          });
        }

        return loginStateByProxy[proxyBase] !== false;
      })
      .catch(function (error) {
        console.warn('[follow] failed to resolve login state', error);
        return true;
      });
  }

  function applyMutationResult(button, proxyBase, influencerHandle, influencerAliases, isFollowing, result) {
    var response = result.response;
    var payload = result.payload;
    var rawText = result.rawText;

    if (response.status === 401) {
      loginStateByProxy[proxyBase] = false;
      handleUnauthorized();
      return;
    }

    if ((payload && payload.message === 'LOGIN_REQUIRED') || rawText === 'LOGIN_REQUIRED' || isLoginRedirect(response)) {
      loginStateByProxy[proxyBase] = false;
      handleUnauthorized();
      return;
    }

    if (isHtmlResponse(response, rawText)) {
      throw new Error('팔로우 처리 중 오류가 발생했습니다.');
    }

    if (!response.ok || (payload && payload.ok === false)) {
      throw new Error(
        getFriendlyErrorMessage(payload && payload.message, response.status),
      );
    }

    loginStateByProxy[proxyBase] = true;

    var nextFollowing =
      payload && typeof payload.following === 'boolean'
        ? payload.following
        : !isFollowing;

    setButtonsState(proxyBase, influencerHandle, nextFollowing);
    scheduleStatusSync();
    document.dispatchEvent(
      new CustomEvent('townwine:follow-change', {
        detail: {
          phase: 'confirmed',
          proxyBase: proxyBase,
          influencerHandle: influencerHandle,
          matchHandles: influencerAliases,
          following: nextFollowing,
        },
      }),
    );

    if (isFollowing && !nextFollowing) {
      showFollowNotice(FOLLOW_NOTICE_UNFOLLOWED);
    }
  }

  function handleFollowClick(button) {
    if (!(button instanceof HTMLButtonElement) || button.disabled) {
      return;
    }

    if (button.dataset.followRequestInFlight === 'true') {
      return;
    }

    var proxyBase = getProxyBase(button);
    var influencerHandle = getButtonHandle(button);
    var influencerAliases = getButtonMatchHandles(button);
    var influencerName = String(button.dataset.influencerName || '').trim();
    var requestContext = getButtonRequestContext(button);
    var loginState = loginStateByProxy[proxyBase];
    var mutationEndpoint = '';
    var mutationPayload = null;
    var mutationFallbackNotice = '';
    var isFollowing = button.getAttribute('aria-pressed') === 'true';
    var nextOptimisticFollowing = !isFollowing;

    if (!influencerHandle) {
      window.alert('먼저 컬렉터 handle 값을 설정해 주세요.');
      return;
    }

    if (!requestContext.customerId) {
      loginStateByProxy[proxyBase] = false;
      handleUnauthorized();
      return;
    }

    if (loginState === false) {
      handleUnauthorized();
      return;
    }

    button.dataset.followRequestInFlight = 'true';
    setButtonsDisabled(proxyBase, influencerHandle, true);
    setButtonsState(proxyBase, influencerHandle, nextOptimisticFollowing);

    var customer = getCustomerContext();
    mutationEndpoint = proxyBase + (isFollowing ? '/unfollow' : '/follow');
    mutationPayload = {
      influencerHandle: influencerHandle,
      influencerName: influencerName,
      customerEmail: customer.email,
      customerFirstName: customer.firstName,
      shop: requestContext.shopDomain,
      logged_in_customer_id: requestContext.customerId,
      returnTo: getReturnTo(button),
    };
    mutationFallbackNotice = isFollowing ? FOLLOW_NOTICE_UNFOLLOWED : '';

    sendMutationRequest(mutationEndpoint, mutationPayload)
      .then(function (result) {
        return {
          isFollowing: isFollowing,
          result: result,
        };
      })
      .then(function (state) {
        if (!state) return;

        applyMutationResult(
          button,
          proxyBase,
          influencerHandle,
          influencerAliases,
          state.isFollowing,
          state.result,
        );
      })
      .catch(function (error) {
        console.error('[follow] request failed', error);
        setButtonsState(proxyBase, influencerHandle, isFollowing);

        if (
          mutationEndpoint &&
          mutationPayload &&
          isRecoverableNetworkError(error) &&
          submitMutationRequestFallback(mutationEndpoint, mutationPayload, {
            notice: mutationFallbackNotice,
          })
        ) {
          return;
        }

        window.alert(
          getFriendlyErrorMessage(error && error.message),
        );
      })
      .finally(function () {
        button.dataset.followRequestInFlight = 'false';
        setButtonsDisabled(proxyBase, influencerHandle, false);
      });
  }

  function bindFollowButton(button) {
    if (!(button instanceof HTMLButtonElement)) return button;

    var boundButton = button;
    var currentBindVersion = String(button.dataset.followBoundVersion || '').trim();
    var hasLegacyInlineHandler = button.hasAttribute('onclick');
    var hasLegacyBinding = button.dataset.followBound === 'true' && currentBindVersion !== FOLLOW_BIND_VERSION;

    if (hasLegacyInlineHandler || hasLegacyBinding) {
      var replacementButton = button.cloneNode(true);
      button.replaceWith(replacementButton);
      boundButton = replacementButton;
    }

    if (boundButton.dataset.followBoundVersion === FOLLOW_BIND_VERSION) {
      return boundButton;
    }

    boundButton.dataset.followBound = 'true';
    boundButton.dataset.followBoundVersion = FOLLOW_BIND_VERSION;
    boundButton.type = 'button';
    boundButton.onclick = null;
    boundButton.removeAttribute('onclick');
    boundButton.addEventListener('click', function (event) {
      if (event && event.__townwineFollowHandled) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      event.__townwineFollowHandled = true;
      handleFollowClick(boundButton);
    });

    return boundButton;
  }

  function bindProductCardNavigation(root) {
    Array.prototype.slice
      .call((root || document).querySelectorAll('[data-townwine-product-card-url]'))
      .forEach(function (card) {
        if (!(card instanceof HTMLElement)) return;
        if (card.dataset.productCardNavBound === 'true') return;

        card.dataset.productCardNavBound = 'true';
        card.addEventListener('click', function (event) {
          if (!event || event.defaultPrevented) return;

          if (event instanceof MouseEvent) {
            if (event.button !== 0) return;
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          }

          if (!(event.target instanceof Element)) return;
          if (event.target.closest('a, button, input, label, select, textarea, summary')) return;

          var productUrl = String(card.dataset.townwineProductCardUrl || '').trim();
          if (!productUrl) return;

          window.location.href = productUrl;
        });
      });
  }

  function initializeFollowButtons(root) {
    getFollowButtons(root || document).forEach(function (button) {
      var boundButton = bindFollowButton(button) || button;

      if (!getButtonHandle(boundButton)) {
        boundButton.disabled = true;
      }
    });

    syncStatuses(root || document);
  }

  function initializeTownWineUi(root) {
    initializeFollowButtons(root || document);
    bindProductCardNavigation(root || document);
  }

  function initialize() {
    if (!initialized) {
      initialized = true;
      showPendingFollowNotice();
      document.addEventListener('shopify:section:load', function (event) {
        initializeTownWineUi(event.target);
      });
    }

    initializeTownWineUi(document);
  }

  window.TownWineFollow = {
    init: initializeTownWineUi,
    syncStatuses: syncStatuses,
    handleButtonClick: function (button, event) {
      if (event) {
        if (event.__townwineFollowHandled) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        event.__townwineFollowHandled = true;
      }

      handleFollowClick(button);
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
